import { CSSProperties, FC, ReactNode } from 'react'
import cn from './index.module.css'
import TooltipWrapper from '@pages/Admin/CourseSettings/components/TooltipWrapper/TooltipWrapper'
import { CheckOutlined } from '@ant-design/icons'
import classNames from 'classnames'

interface IEmailVerifyWrapper {
  style?: CSSProperties
  visible?: boolean
  verified?: boolean
  children: ReactNode
}

const EmailVerifyWrapper: FC<IEmailVerifyWrapper> = ({
  style,
  visible = false,
  verified = false,
  children,
}) => {
  return (
    <div style={style} className={cn.wrapper}>
      {children}
      {visible && (
        <TooltipWrapper
          className={classNames(
            cn.emailVerifiedIcon,
            verified && cn.emailVerifiedDone,
          )}
          title={verified ? 'Почта подтверждена' : 'Почта не подтверждена'}
        >
          <CheckOutlined
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        </TooltipWrapper>
      )}
    </div>
  )
}

export default EmailVerifyWrapper
